import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { ThemeProvider } from '@/lib/theme';
// Provides the .tf-header* class definitions used by <TrackframeHeader />.
// Without this the header in HubLayout renders unstyled. MUST be imported
// BEFORE index.css: this file is a compiled Tailwind build whose preflight
// (`* { border: 0 solid }` → currentColor) lands in the same `base` layer as
// index.css's `* { border-color: var(--border) }` — whichever comes later in
// source order wins, and it has to be ours or every border renders near-black.
import '@verybigthings/trackframe-hub-client/ui/styles.css';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
